/* ========================================
   SOFT NAVIGATION (Swup PJAX) — gapless music + instant page transitions
   Swaps only #MainContent on navigation, so header/footer/music-player/cart
   (which live OUTSIDE #MainContent) persist — the <audio> element is never
   destroyed → music plays gapless across page changes.

   SAFETY RAILS:
   - Disabled in Shopify theme editor (Shopify.designMode)
   - Excludes /cart, /checkout, /account, /admin, ?, and external links
   - Re-executes section <script> tags after each swap (they don't auto-run)
   - Fires `sync:page-loaded` so per-page features re-init
   - Any failure → falls back to normal full navigation (never worse than MPA)
   ======================================== */
(function () {
  // Bail in theme editor — Shopify injects its own design-mode machinery that
  // assumes full page loads.
  if (window.Shopify && window.Shopify.designMode) return;
  if (typeof Swup === 'undefined') return;
  if (!document.getElementById('MainContent')) return;

  // Honour reduced-motion: still soft-navigate (for gapless audio) but no animation.
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var swup;
  try {
    swup = new Swup({
      containers: ['#MainContent'],
      animationSelector: reduce ? false : '[class*="swup-transition"]',
      linkSelector: 'a[href]',
      // Skip URLs that must do a real navigation.
      ignoreVisit: function (url) {
        return /\/(cart|checkout|account|admin)(\/|$|\?)/.test(url) ||
               /\/cart\//.test(url);
      }
    });
  } catch (e) {
    return; // Swup failed to init → plain MPA navigation stays in effect.
  }

  // Re-execute <script> tags inside the freshly-swapped container. Browsers do
  // NOT run scripts inserted via innerHTML, so section JS (collection, product,
  // slideshow, hero) would otherwise be dead after a soft-nav.
  function reexecuteScripts() {
    var container = document.getElementById('MainContent');
    if (!container) return;
    var scripts = container.querySelectorAll('script');
    scripts.forEach(function (old) {
      var s = document.createElement('script');
      // copy attributes (src, type, defer…)
      for (var i = 0; i < old.attributes.length; i++) {
        var a = old.attributes[i];
        s.setAttribute(a.name, a.value);
      }
      if (!old.src) s.textContent = old.textContent;
      old.parentNode.replaceChild(s, old);
    });
  }

  // Keep the <body> template-* class in sync with the page we navigated to.
  // The header lives OUTSIDE #MainContent (so it persists for gapless music),
  // and its homepage hide rule is `body.template-index .header--hide-home`.
  // Swup only swaps #MainContent, so without this the body keeps the previous
  // page's template-* class → header stays hidden after leaving the homepage,
  // or shows incorrectly when arriving on it. We mirror Shopify's own body
  // class scheme: template-{handle}.
  function syncBodyTemplateClass(html) {
    try {
      var m = html && html.match(/<body[^>]*\sclass="([^"]*)"/i);
      if (!m) return;
      var incoming = m[1].split(/\s+/);
      var incomingTemplate = incoming.filter(function (c) { return c.indexOf('template-') === 0; });
      if (!incomingTemplate.length) return;
      // strip existing template-* classes, add the new ones
      document.body.className = document.body.className
        .split(/\s+/)
        .filter(function (c) { return c && c.indexOf('template-') !== 0; })
        .concat(incomingTemplate)
        .join(' ');
    } catch (e) { /* non-fatal: header just won't toggle until reload */ }
  }

  // Swup exposes the fetched HTML on the visit/page object across versions;
  // fall back to reading document state if unavailable.
  swup.hooks.on('content:replace', function (visit) {
    var html = (visit && visit.to && visit.to.html) ||
               (swup.cache && swup.cache.get && swup.cache.get(location.pathname) && swup.cache.get(location.pathname).html) ||
               '';
    syncBodyTemplateClass(html);
  });

  swup.hooks.on('page:view', function () {
    reexecuteScripts();
    // Let global + per-feature scripts know fresh content is in the DOM.
    document.dispatchEvent(new CustomEvent('sync:page-loaded'));
    // Restore scroll to top on new page (Swup keeps position otherwise on some flows).
    try { window.scrollTo(0, 0); } catch (e) {}
  });

  // Expose for debugging / other scripts.
  window.__syncSwup = swup;
})();
